import React from 'react';
import auth from 'ThreeTerminal_base/auth';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { rel } from '@ifeng-fe/container_channel/common/client/utils/rel.js';
import styles from './index.css';

class CommentTextareaBottom extends React.PureComponent {
    static propTypes = {
        loginId: PropTypes.string,
        userInfo: PropTypes.object,
        myComUrl: PropTypes.string,
    };
    // 凤凰全站登录,
    ifengLogin = () => {
        auth.login(this.props.loginId);
    };

    // sina用户登录
    sinaLogin = () => {
        const sinaAPI =
            'https://api.weibo.com/oauth2/authorize?client_id=1073104718&redirect_uri=http%3A%2F%2Fid.ifeng.com%2Fcallback%2Fsina&response_type=code';
        const logWin_width = '770';
        const logWin_height = '630';

        window.open(sinaAPI, logWin_width, logWin_height);

        auth.login(this.props.loginId);
    };

    // 登出
    logOut = () => {
        auth.logout();
    };

    render() {
        const { userInfo, myComUrl } = this.props;

        return (
            <div className={styles.comment_textarea_bottom}>
                {JSON.stringify(userInfo) !== '{}' ? (
                    <React.Fragment>
                        <span className={styles.userinfo}>{userInfo && userInfo.userName}</span>
                        <span className={styles.line}>/</span>
                        <a href={myComUrl} target="_blank" rel={rel} className={styles.account}>
                            我的评论
                        </a>
                        <span className={styles.line}>/</span>
                        <a className={styles.account} onClick={this.logOut}>
                            退出
                        </a>
                    </React.Fragment>
                ) : (
                    <React.Fragment>
                        <span className={styles.userinfo}>一键登录： </span>
                        <a className={styles.account} onClick={this.ifengLogin}>
                            凤凰账号
                        </a>
                        <span className={styles.line}>/</span>
                        <a className={styles.account} onClick={this.sinaLogin}>
                            新浪微博
                        </a>
                    </React.Fragment>
                )}
            </div>
        );
    }
}

export default errorBoundary(CommentTextareaBottom);
